// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3574":"16196e86","4835":"16196e86","8910":"16196e86","9010":"16196e86"}[chunkId] + ".chunk.css";
};